var _style, _path, _rect, _rect2, _g, _path2, _path3, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g4, _g5, _g6, _g7, _path11, _polygon, _polygon2, _path12, _circle, _path13, _rect3, _rect4, _g8, _rect5, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationRooms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 550",
    style: {
      enableBackground: "new 0 0 850 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#FFB6B6;}\n\t.st3{fill:#2F2E41;}\n\t.st4{opacity:0.1;enable-background:new    ;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#A0616A;}\n\t.st7{fill:url(#SVGID_1_);}\n\t.st8{fill:url(#SVGID_00000147183800075996192350000007438860293001034410_);}\n\t.st9{fill:url(#SVGID_00000173138423804887244330000004358810976261508262_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M780,265.6H98.9c-9.1,0-16.6-7.4-16.6-16.6V16.6C82.3,7.4,89.8,0,98.9,0H780c9.1,0,16.6,7.4,16.6,16.6v232.5 C796.6,258.2,789.2,265.6,780,265.6z M98.9,2c-8,0-14.6,6.5-14.6,14.6v232.5c0,8,6.5,14.6,14.6,14.6H780c8,0,14.6-6.5,14.6-14.6 V16.6C794.6,8.5,788.1,2,780,2H98.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "uuid-dac6dc9f-03bc-4283-a90c-97bcdcbf45dc",
    x: 5.1,
    y: 543.4,
    className: "st1",
    width: 839.9,
    height: 1.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "uuid-2f9646f7-bb94-4523-8d2e-fd8f0877664c",
    x: 5.1,
    y: 458.5,
    className: "st1",
    width: 839.9,
    height: 1.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "uuid-bb35f39c-94aa-41c4-b5d9-34ca9a9e88f1-172",
    className: "st2",
    d: "M387.8,274.2c0.6,7.6,5,13.4,9.9,13 c4.8-0.4,8.3-6.8,7.6-14.4c-0.2-3.1-1.1-6-2.7-8.6l-3-32.1l-15,1.7l4.5,31.5C388,268,387.6,271.1,387.8,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.9,124.4c0,0,14-7.4,21.1,3.7c7.1,11.1,12,131.3,12,131.3l-19.7,2.1l-3.8-84.7L369.9,124.4L369.9,124.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "340.7,452.2 352.2,452.2 357.6,408.1 340.7,408.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M379.9,451.9L379.9,451.9c0.4,0.6,0.6,2.6,0.6,3.3l0,0c0,2.2-1.8,3.8-3.8,3.8h-35.4c-1.5,0-2.7-1.2-2.7-2.7 V455c0,0-1.8-4.4,1.9-9.9c0,0,4.4,4.2,11.2-2.5l2-3.6l14.3,10.5l7.9,1C377.5,450.7,379,450.4,379.9,451.9L379.9,451.9 L379.9,451.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "406.9,450.3 418,447.5 412.4,403.3 396,407.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M444.8,440.4L444.8,440.4c0.5,0.5,1.2,2.4,1.3,3l0,0c0.5,2.1-0.7,4.1-2.8,4.7l-34.3,8.8 c-1.4,0.4-2.9-0.5-3.3-1.9l-0.4-1.4c0,0-2.8-3.8-0.7-10.1c0,0,5.4,3.1,10.3-5.1l1-3.9l16.5,6.6l7.9-1 C442.2,439.8,443.6,439.2,444.8,440.4L444.8,440.4L444.8,440.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "331.2,115 330.8,111 337.2,95.3 354.8,93.4 358.7,115.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "331.2,115 330.8,111 337.2,95.3 354.8,93.4 358.7,115.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "310.6,226.2 302.7,247.8 308.6,259.6 338.2,430.8 357.8,430.8 353.9,279.3 399.1,430.8 418.6,430.8  403,328.4 391.2,234 384.2,229.7 350,210.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "360.8,240.9 349,242.9 333.2,205.5 368.6,205.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "384.4,231 360.8,240.9 353,223.2 349,242.9 307.7,229.6 313.6,205.5 307.7,126.8 328.5,112.9  331.2,111 356.8,113 359.1,114.3 374.6,122.9 378.5,187.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "359.1,114.3 348,161.3 328.5,112.9 331.2,111 356.8,113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "340.1,111 336.2,117.8 340.1,120.1 338.2,161.4 346,172 353.9,156.2 348,120.1 350,111  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 346,
    cy: 88.4,
    r: 18.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.1,90.1l4,1.8l1.8-10.6c0,0,7-3.6,12.3-1.8c5.3,1.8,14.1,0,14.1,0s0-17.7-12.3-17.7s-24.7,1.8-24.7,7 S324,79.4,324,79.4s-7,10.6,0,17.7c7,7.1,10.6,7,10.6,7L334.1,90.1L334.1,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-97233535-ec91-4408-928f-bf1e5273ca3e-173",
    className: "st2",
    d: "M297.8,273.6c-0.2,7.6,3.6,13.9,8.4,14 c4.8,0.1,8.9-5.9,9.1-13.5c0.1-3.1-0.5-6-1.8-8.8l0.5-32.2l-15.1,0.1l1.2,31.8C298.6,267.5,297.9,270.6,297.8,273.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M316.5,122.9c0,0-12.8-3.9-18.7,7.9c-5.9,11.8,2,131.9,2,131.9h19.8l-5.2-84.6L316.5,122.9L316.5,122.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M807.1,346.4l-47.7-14.6c-1.1-0.3-2.2-0.4-3.3-0.4l-241.7,20.5c-3.5,0.3-4.3,4.9-1.2,6.4l7.7,3.8h-0.2v180.6 h7.3v-177l24.3,11.8c1.9,0.9,3.9,1.3,6,1.1l2.6-0.3v164.4h7.3V377.6l186.8-18.8v184.1h7.3V357.9l31-3.2v188h7.3V354.1l5.6-0.6 C810.4,353.1,810.9,347.6,807.1,346.4L807.1,346.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M584.6,351.3c4.5,0,72-8.2,72-8.2l10.1,13.7l-70.2,13.7L584.6,351.3L584.6,351.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "658.7,535.8 647,535.8 641.4,490.6 658.8,490.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M618.5,535.5L618.5,535.5c-0.4,0.6-0.6,2.6-0.6,3.4l0,0c0,2.2,1.8,3.9,3.9,3.9l36.3,0.1 c1.5,0,2.8-1.2,2.8-2.7v-1.5c0,0,1.8-4.5-1.9-10.2c0,0-4.6,4.3-11.4-2.5l-2-3.7L631,533.1l-8.1,1 C621,534.2,619.4,533.9,618.5,535.5L618.5,535.5L618.5,535.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "721.6,514.8 712.4,521.8 681,489.4 694.7,479.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M689.8,538.5L689.8,538.5c0.1,0.7,1.1,2.4,1.6,3l0,0c1.3,1.8,3.8,2.1,5.5,0.8l28.6-21.6 c1.2-0.9,1.4-2.6,0.5-3.8l-0.9-1.2c0,0-1.3-4.6-7.5-6.9c0,0-1,6.2-10.6,4.8l-3.8-1.7l-5.2,17.2l-5.8,5.6 C691,536,689.6,536.7,689.8,538.5L689.8,538.5L689.8,538.5z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M697.1,281c0,10.9-8.8,19.5-19.5,19.5S658,291.7,658,281c0-10.8,8.8-19.5,19.5-19.5S697.1,270.2,697.1,281z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M695.2,393.9c0,0-72-4-76.2,4c-4.1,8.1,22,120.2,22,120.2l23.3-4.9L653,434.5c0,0,60.1,15.9,68.3-3.2 c8.2-19,5.8-26.2,5.8-26.2L695.2,393.9L695.2,393.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M713.7,380.2c0,0-70.6,15.1-72.3,24.1s53.1,110.1,53.1,110.1l21.2-10.9l-31.8-72.8c0,0,62.2-0.6,65-21 c2.9-20.4-1.3-26.7-1.3-26.7L713.7,380.2L713.7,380.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 662.2072,
    y1: 3992.4451,
    x2: 733.1866,
    y2: 3992.4451,
    gradientTransform: "matrix(1 0 0 1 0 -3637.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M721.8,303.5h-33.9l-23.2,38.1c0,0-5.4,24.6,0,27.2c5.4,2.7,5.4,31.2,5.4,31.2l57.1,5.4 c0,0,8.2-85.7,5.4-93.9C729.9,303.4,721.8,303.5,721.8,303.5z M691.2,313.6c0,0-9.5-12.2-16.3-2.8c-6.8,9.5-12.2,21.7-12.2,21.7 l27.2,9.5L691.2,313.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M668.1,328.6l-3.4,40.2l-38.2-16.2l-9.1-4.6c-1.8-2.4-4.1-4.2-6.8-5.4c-6.6-3.3-13.6-2.5-15.7,1.8 c-2.1,4.2,1.7,10.3,8.3,13.4c2.7,1.3,5.5,2,8.5,2l26.7,15.2v-0.1l0.1,0.2l41.8,17.5l9.7-52.7L668.1,328.6L668.1,328.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M663.9,283.7c0,0-20.4,2.8-12.2-15c0,0-1.3-9.6,4.8-10.3c6.1-0.7,14.2-11.5,14.2-11.5s18.8-9.5,28.4,0 c9.7,9.5,38.3,65.2,38.3,65.2l-19,20.4c0,0-11.4-30.1-24.8-26.6c-13.3,3.5-25.6,13.9-25.6,13.9s-13.5-6.8-7.4-12.6 C666.8,301.4,663.9,283.7,663.9,283.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M794.4,540.1l-31.6-100.5l0,0h0.1l-0.1-0.2l0,0l-2.3-7.1l0,0c3.5-3,5.7-7.2,6.2-12l-14.4-79.4 c1-10.5-7-19.5-17.5-19.9l-32.6-0.1c-9.3-0.3-17.3,6.3-18.7,15.5l-0.7,4.8l-10,67.9c-0.4,2.5-0.2,4.8,0.4,7.1l-7.2,1l-2.2,0.3 l-8.6,1.1l0,0l-1.1,0.1h-1.2v29.2h0.1v93.3c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-93.3h12.8L681,541c0.1,0.6,0.6,1,1.1,1 h0.1c0.6-0.1,1-0.6,1-1.3L670.2,448h61.4c6.1,0,11.7-2,16.3-5.2l24.3,98.2c0.1,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3,0 c0.6-0.2,1-0.8,0.8-1.4l-24.6-99.2c0.3-0.3,0.7-0.6,1-0.9l9.8-0.6l31.8,101c0.1,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3-0.1 C794.3,541.3,794.6,540.7,794.4,540.1L794.4,540.1z M758.5,433.9c0.1,0,0.2-0.1,0.2-0.1l0,0l0.2,0.8L758.5,433.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "174.4,369.9 195.6,356.4 204.3,361.6 174.4,395.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.3,317.5c0,0-14.1,3.4-7.5,22.4c6.6,19.1,28.2,59,34.9,56.5c6.7-2.5,7.5-27.4,7.5-27.4s-0.8,0.8-4.1-2.5 c-3.4-3.3-3.4-1.8-3.4-5.4s-2.8-6.4-2.8-6.4l-3.1-6.4c0,0,0-29.9-12.4-31.6C142,315,145.3,317.5,145.3,317.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -190.5935 248.8631)",
    className: "st2",
    cx: 205.1,
    cy: 354.5,
    rx: 14.1,
    ry: 8.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90.2,427.6 104.8,451.6 189.3,446.7 166.8,417.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.6,539.9c-0.5,0-0.9-0.4-1-0.9L89.4,354.5c-0.1-0.6,0.3-1.1,0.9-1.1c0.6-0.1,1.1,0.3,1.1,0.9l25.3,184.6 C116.7,539.4,116.3,539.9,115.6,539.9L115.6,539.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.2,540.2c-0.6,0-1-0.5-1-1V354.4c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v184.7 C91.3,539.7,90.8,540.2,90.2,540.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M217.2,539.4c-0.4,0-0.8-0.3-1-0.7l-59.8-190.1c-0.2-0.5,0.1-1.1,0.7-1.3c0.5-0.2,1.1,0.1,1.3,0.7 l59.8,190.1c0.2,0.5-0.1,1.1-0.7,1.3C217.4,539.4,217.3,539.4,217.2,539.4L217.2,539.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.9,539.7c-0.5,0-0.9-0.3-1-0.8l-41.5-167.8c-0.1-0.5,0.2-1.1,0.7-1.2s1.1,0.2,1.2,0.7l41.5,167.8 c0.1,0.5-0.2,1.1-0.7,1.2C199,539.6,199,539.7,198.9,539.7L198.9,539.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "90.2,357.4 159.6,356.3 172.4,429.1 91.3,429.1  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "196.8,464.4 179.4,495.2 199.6,499.7 208.1,477.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.6,489.4c0,0-0.7-5-4.6-3.5c-3.9,1.6-15.5,7.5-15.5,7.5s30,48.9,35.7,46.5c5.7-2.3-1.1-16.1-1.1-16.1 l1.5-24.4L185.6,489.4L185.6,489.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.6,404.7c0,0-6.2,28.6,12.9,38.7c19.1,10.1,84.4-14.5,84.4-14.5l-30,44.8l20.7,8.4 c0,0,47.4-62.3,44-72.2c-3.4-10-25.8-10.8-25.8-10.8l-50.7,2.5l-13.3-4.1C161.9,397.3,119.6,404.7,119.6,404.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "171,478.1 143.5,500.4 160.8,511.9 176.6,494.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.4,497.2c0,0,1.2-4.9-3.1-4.9c-4.2,0-17.2,1.4-17.2,1.4s10.3,56.4,16.4,56.4c6.1,0,4.8-15.4,4.8-15.4 l10.3-22.2L151.4,497.2L151.4,497.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.7,394.4c0,0-16.3,24.5-2.1,40.7c14.2,16.2,83.9,17.2,83.9,17.2l-44.2,30.9l16.3,15.3 c0,0,66.8-40.9,67.3-51.3s-20-19.4-20-19.4l-48.2-16.1l-10.9-8.7L120.7,394.4z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.4,337.8c0,0-15.8-5.8-23.3-5.8c-0.7,0-1.4,0.1-2.2,0.2c-4.7,1-9.2,5.1-11.3,7.4 c-0.8,0.9-1.3,1.5-1.3,1.5s0.1-0.6,0.2-1.6c0.5-5.3,2.3-22.6,5.5-33.8c1.2-3.9,2.5-7.1,4-8.7c3.6-3.6,5.2-7.9,6-11.1 c0.7-2.8,0.7-4.6,0.7-4.6l-6-2.6l-1.1-7.3c-0.2,0.9-1.1,2.6-4.2,5.8c-0.3,0.3-0.6,0.5-0.9,0.7c-4.4,2.8-13.6-2.1-18.5-5.1 c2.1-7.1,5.7-13.6,12.4-14.7c15.8-2.5,15.8-11.6,25.8-1.7c0.8,0.8,1.7,1.6,2.5,2.4c3.2,6.1,4.3,14.3,4.7,19.9 c0.3,3.9,0.2,6.7,0.2,6.7s4.1,25,10.8,29.9S162.4,337.8,162.4,337.8L162.4,337.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "131.7,297.9 120.4,314.4 145.8,321.1 145.8,297.9  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "131.7,297.9 120.4,314.4 145.8,321.1 145.8,297.9  "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.4,313.7l-24.1-10c0,0-32.4,14.1-29.9,41.5c2.5,27.4,25.8,74.8,25.8,74.8l46.5-19.9l-5-53.2L147.4,313.7 L147.4,313.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 137,
    cy: 284,
    r: 21.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.7,276.3c-4.1,4.1-7.5,8.3-7.5,8.3l-1.7-6.6c0,0-0.4,0.3-1.1,0.7c-2.7,1.8-9.7,6.3-15.4,7.3 c-2.6,0.4-4.7,0.2-6.2-1.4c-3.1-3.3-4-4.9-4.2-5.8l-1.1,7.3l-6,2.6c0,0,0,9.1,6.6,15.8c0.3,0.3,0.6,0.7,1,1.2 c3.2,4.7,5.4,16.5,6.9,26.4c1.3,8.9,1.9,16.3,1.9,16.3s-6.3-7.9-13.2-9c-0.4-0.1-0.8-0.1-1.2-0.1c-0.1,0-0.3,0-0.4,0 c-7.5,0-23.3,5.8-23.3,5.8s-10.8-17.5-4.1-22.4c6.6-5,10.8-29.9,10.8-29.9s-0.3-10.7,2.5-20.2c2.1-7.1,5.7-13.6,12.4-14.7 c15.8-2.5,15.8-11.6,25.8-1.7c0.8,0.8,1.7,1.6,2.5,2.4C160.1,267.3,169.6,272.5,165.7,276.3L165.7,276.3z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6,
    y: 387.9,
    className: "st0",
    width: 7.9,
    height: 155.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 387.9,
    className: "st0",
    width: 7.9,
    height: 155.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009549233181752734050000015049630228119750298_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.3,
    y1: 3985.8823,
    x2: 213.6058,
    y2: 3985.8823,
    gradientTransform: "matrix(1 0 0 1 0 -3637.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.3,
    y: 321.7,
    style: {
      fill: "url(#SVGID_00000009549233181752734050000015049630228119750298_)"
    },
    width: 52.3,
    height: 52.3
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "131.2,377.4 152.4,363.8 161.1,369 131.2,403.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.1,325c0,0-14.1,3.4-7.5,22.4c6.6,19,28.2,59,34.9,56.5c6.7-2.5,7.5-27.4,7.5-27.4s-0.8,0.8-4.1-2.5 c-3.4-3.4-3.4-1.8-3.4-5.4s-2.8-6.4-2.8-6.4l-3.1-6.4c0,0,0-29.9-12.4-31.6C98.7,322.5,102.1,325,102.1,325z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -208.5691 220.5006)",
    className: "st2",
    cx: 161.9,
    cy: 362,
    rx: 14.1,
    ry: 8.7
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9,
    y: 381.9,
    className: "st0",
    width: 238.8,
    height: 17.8
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.2,239.8h35.2c2.8,0,5,2.3,5,5v14.5c0,2.8-2.3,5-5,5h-35.2c-2.8,0-5-2.3-5-5v-14.5 C482,242.1,484.3,239.8,487.2,239.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085953442108911175420000006901295395157509555_",
    gradientUnits: "userSpaceOnUse",
    x1: 556.0939,
    y1: 3897.3572,
    x2: 601.4914,
    y2: 3897.3572,
    gradientTransform: "matrix(1 0 0 1 0 -3637.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085953442108911175420000006901295395157509555_)"
    },
    d: "M561.2,254.3h35.2c2.8,0,5,2.3,5,5l0,0 c0,2.8-2.3,5-5,5h-35.2c-2.8,0-5-2.3-5-5l0,0C556.1,256.6,558.3,254.3,561.2,254.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationRooms);
export default __webpack_public_path__ + "static/media/illustration_rooms.007621cc0e538b23024cc99fc0692708.svg";
export { ForwardRef as ReactComponent };